exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tips-text[data-v-7c2d5ad2] {\n  font-size: small;\n}\n", ""]);

// exports
